import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { mergeTrees, userItemsPerListMixin } from '../../utils/vuex';
import { mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewAccountMgmtAccountMgmtRoleEditor',
  mixins: [userItemsPerListMixin],
  data: function data() {
    return {
      showDialogRoleWizardDelete: false,
      confirmRoleWizardDeleteId: null,
      tenants: [],
      activeTenants: [],
      selectedTenant: null,
      roleEditorStepIndex: 1,
      tabItem: null,
      treeSearch: null,
      buttons01: [],
      rolesForScope: [],
      roleList: [],
      ruleList: [],
      roleEditItem: null,
      roleAddDialog: false,
      expandedRows: [],
      tableOptions: _objectSpread({}, defaultTableOptions),
      serverItemsLength: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    buttonsRoleList: function buttonsRoleList() {
      return [{
        icon: 'fal fa-plus',
        action: 'openRoleAddDialog',
        valid: this.activeTenants.length > 0,
        title: this.$i18n_t('Common.create'),
        tooltip: this.$i18n_t('Common.create')
      }];
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: this.$i18n_t('accMgmt.tenant.roleIcon'),
          value: null,
          width: '30px'
        }, {
          sortable: true,
          text: 'ID',
          value: 'id'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.tenant.roleName'),
          value: 'name'
        }, {
          sortable: false,
          text: this.$i18n_t('accMgmt.tenant.roleDescription'),
          value: 'description'
        }, {
          sortable: false,
          text: this.$i18n_t('accMgmt.tenant.permissions'),
          value: null
        }, {
          sortable: false,
          text: this.$i18n_t('Common.actions'),
          value: '',
          align: 'right'
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    },
    selectedTenant: function selectedTenant() {
      this.fetchRules();
    }
  },
  mounted: function mounted() {
    this.checkAccess();
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    openRoleAddDialog: function openRoleAddDialog() {
      this.roleEditItem = {
        properties: {}
      };
      this.roleAddDialog = true;
    },
    openRoleEditDialog: function openRoleEditDialog(item) {
      this.roleEditItem = cloneDeep(item);

      if (!this.roleEditItem.properties) {
        this.roleEditItem.properties = {};
      }

      this.roleAddDialog = true;
    },
    saveTab01: function saveTab01() {
      this.$refs.accessSelector.handleSubmit();
    },
    closeTab01: function closeTab01() {
      this.$refs.accessSelector.close();
    },
    checkAccess: function checkAccess() {
      if (this.permissions['all.manage']) {
        this.fetchRules();
        this.fetchTenant();
      }
    },
    fetchTenant: function fetchTenant() {
      var _this = this;

      // NOTE: do not use 'authentication/primaryTenantIds' here, since those are not guaranteed to be
      // `all.manage` accounts. Instead, the `all.manage.tenantIds` is an already filtered list of tenantIds,
      // of which the user has all.manage on tenant-scope level
      return Promise.all(this.permissions['all.manage.tenantIds'].map(function (tenantId) {
        return ApiService.tenantGetById(tenantId, ['no-scope-descendents']);
      })).then(function (tenants) {
        tenants.forEach(function (tenant) {
          if (!tenant.data) {
            tenant.data = {};
          }
        });

        if (!_this.selectedTenant && tenants.length > 0) {
          _this.selectedTenant = tenants[0];
        }

        _this.tenants = mergeTrees(tenants);

        _this.fetchRoles();
      }).catch(function (error) {
        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack(_this.$i18n_t('Common.tenantReadFail'), 'error');
        }
      }).finally(function () {
        _this.$store.state.app.loading = false;
      });
    },
    fetchRoles: function fetchRoles() {
      var _this2 = this;

      ApiService.fetchRoles(this.selectedTenant.scopeId, null, true).then(function (roles) {
        _this2.roleList = roles;
        _this2.serverItemsLength = roles.length;
      }).catch(function (error) {
        console.error(error);
      });
    },
    confirmDeleteRole: function confirmDeleteRole(id) {
      this.showDialogRoleWizardDelete = true;
      this.confirmRoleWizardDeleteId = id;
    },
    deleteRole: function deleteRole(id) {
      var _this3 = this;

      this.confirmRoleWizardDeleteId = null;
      ApiService.deleteRole(id).then(function () {
        _this3.fetchRoles();
      }).catch(function (error) {
        console.error(error);
      });
    },
    fetchRules: function fetchRules() {
      var _this4 = this;

      if (!this.selectedTenant) {
        return;
      }

      ApiService.fetchRulesByTenant(this.selectedTenant.id).then(function (rules) {
        rules.sort(function (a, b) {
          return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
        });
        _this4.ruleList = rules;
      }).catch(function (error) {
        console.error(error);
      });
    },
    changedSelectedTenant: function changedSelectedTenant(tenantIds) {
      if (!tenantIds.length || !this.tenants || !this.tenants.length) {
        return;
      }

      this.selectedTenant = this.findTenantInTreeArray(this.tenants, tenantIds[0]);
      this.roleEditorStepIndex = 2;
      this.fetchRoles();
    },
    findTenantInTreeArray: function findTenantInTreeArray(treeArray, tenantId) {
      for (var i = 0; i < treeArray.length; i++) {
        var foundTenant = this.findTenantInTree(treeArray[i], tenantId);

        if (foundTenant) {
          return foundTenant;
        }
      }

      return null;
    },
    findTenantInTree: function findTenantInTree(tree, tenantId) {
      if (tree.id === tenantId) {
        return tree;
      }

      if (tree.children && tree.children.length > 0) {
        return this.findTenantInTreeArray(tree.children, tenantId);
      }

      return null;
    },
    tenantTreeIcon: function tenantTreeIcon(tenant) {
      return !tenant.parentId ? 'fal fa-users' : !tenant.children || tenant.children.length === 0 ? 'fal fa-user' : 'fal fa-user-friends';
    },
    refreshRoles: function refreshRoles() {
      this.$snack(this.$i18n_t('Common.userUpdated'), 'success');
      this.expandedRows = [];
      this.roleAddDialog = false;
      this.fetchRoles();
    },
    fetchDefaultRolesForScope: function fetchDefaultRolesForScope(scopeId) {
      var _this5 = this;

      ApiService.fetchDefaultRoles(scopeId, true).then(function (roles) {
        _this5.rolesForScope = roles.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    processDefaultRoles: function processDefaultRoles(roles, scopeId) {
      var _this6 = this;

      ApiService.updateDefaultRoles(scopeId, roles.map(function (role) {
        return role.id;
      })).then(function () {
        _this6.$snack(_this6.$i18n_t('Common.userUpdated'), 'success');
      }).catch(function (error) {
        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    setCurrentTablePage: function setCurrentTablePage(value) {
      this.tableOptions.page = value;
    }
  }
};